import {
  GradingReferenceProvider,
  type GradingReferenceWrapper,
} from "@repo/ui/structuredContent/gradingReferenceContext";
import { PlaybookFeedbackReferenceProvider } from "@repo/ui/structuredContent/playbookFeedbackReferenceContext";
import { TeammateReferenceProvider } from "@repo/ui/structuredContent/teammateReferenceContext";
import type { FC, ReactNode } from "react";
import { GradingReferenceLinkAdapter } from "../teammatePerformance/gradingReferenceLinkAdapter.js";
import { PlaybookFeedbackReferenceLinkAdapter } from "../teammatePerformance/playbookFeedbackReferenceLinkAdapter.js";
import { TeammateReferenceLinkAdapter } from "../teammatePerformance/teammateReferenceLinkAdapter.js";

interface AgentOutputReferenceProvidersProps {
  /** Replaces the default grading link, e.g. to open the interaction in place. */
  gradingReferenceWrapper?: GradingReferenceWrapper;
  children: ReactNode;
}

/**
 * The link adapters for every reference kind an agent's structured output can
 * contain: chat transcripts and saved artifacts alike. Add new kinds here so
 * each surface picks them up.
 */
export const AgentOutputReferenceProviders: FC<
  AgentOutputReferenceProvidersProps
> = ({ gradingReferenceWrapper, children }) => (
  <GradingReferenceProvider
    value={gradingReferenceWrapper ?? GradingReferenceLinkAdapter}
  >
    <TeammateReferenceProvider value={TeammateReferenceLinkAdapter}>
      <PlaybookFeedbackReferenceProvider
        value={PlaybookFeedbackReferenceLinkAdapter}
      >
        {children}
      </PlaybookFeedbackReferenceProvider>
    </TeammateReferenceProvider>
  </GradingReferenceProvider>
);
